/* Alpha 3D lithophane photo upload and live preview.
   Shows the uploaded photo as a 4 x 6 in lithophane (lit or unlit, black and white or full color,
   panel, frame or LED frame), lets the customer drag and zoom to pick the crop, and on Add to cart
   posts the product form itself with the original photo and the exact crop as line item properties.
   Markup and styles live in snippets/alpha-photo-upload.liquid. */
(function () {
  var MAX_BYTES = 20 * 1024 * 1024;
  var DPI = 100;           // preview canvas pixels per inch
  var EXPORT_SCALE = 3;    // crop file is 300 pixels per inch
  var PANEL_IN = [4, 6];   // panel size in inches, short side first

  function init() {
    var box = document.getElementById('a3-upload');
    var form = document.querySelector('form[data-type=add-to-cart-form]');
    if (!box || !form) return;

    // form.id would return the form's <input name=id>, so read the attribute.
    var formId = form.getAttribute('id');
    box.querySelectorAll('input, select, textarea').forEach(function (el) { el.setAttribute('form', formId); });

    var $ = function (sel) { return box.querySelector(sel); };
    var input = $('#a3-photo');
    var drop = $('.a3-upload__drop');
    var ui = $('.a3-upload__ui');
    var fileRow = $('.a3-upload__preview');
    var orient = $('#a3-orient');
    var err = $('.a3-upload__err');
    var lp = $('#lp');
    var stage = $('.lp-stage');
    var panel = $('.lp-panel');
    var canvas = $('#lp-canvas');
    var zoom = $('#lp-zoom');
    var hint = $('.lp-hint');
    var addButton = form.querySelector('[type=submit][name=add]');
    var work = document.createElement('canvas');

    var state = { img: null, lit: true, ox: 0, oy: 0, style: optionValue('Style', 'Black & White'), display: optionValue('Display', 'Panel only') };
    var busy = false;

    function optionValue(name, fallback) {
      var checked = document.querySelector('input[type=radio][name=' + name + ']:checked');
      return checked ? checked.value : fallback;
    }

    function landscape() { return orient.value.indexOf('Landscape') === 0; }
    function framed() { return state.display.indexOf('Framed') === 0; }
    function led() { return state.display.indexOf('LED') > -1; }
    function color() { return state.style.indexOf('Color') > -1; }

    function showError(msg) {
      err.textContent = msg;
      err.hidden = false;
      box.scrollIntoView({ block: 'center', behavior: 'smooth' });
    }

    // Draw the photo cover-fitted into a w x h box, using the customer's zoom and position.
    function drawCrop(ctx, w, h) {
      var img = state.img;
      var iw = img.naturalWidth || img.width, ih = img.naturalHeight || img.height;
      var scale = Math.max(w / iw, h / ih) * (zoom.value / 100);
      var dw = iw * scale, dh = ih * scale;
      // Keep the photo covering the panel so no empty edges are printed.
      var maxX = Math.max(0, (dw - w) / 2), maxY = Math.max(0, (dh - h) / 2);
      state.ox = Math.max(-maxX / w, Math.min(maxX / w, state.ox));
      state.oy = Math.max(-maxY / h, Math.min(maxY / h, state.oy));
      ctx.drawImage(img, (w - dw) / 2 + state.ox * w, (h - dh) / 2 + state.oy * h, dw, dh);
    }

    function render() {
      if (!state.img) return;
      var w = (landscape() ? PANEL_IN[1] : PANEL_IN[0]) * DPI;
      var h = (landscape() ? PANEL_IN[0] : PANEL_IN[1]) * DPI;
      canvas.width = w; canvas.height = h;
      work.width = w; work.height = h;
      var wc = work.getContext('2d');
      wc.clearRect(0, 0, w, h);
      drawCrop(wc, w, h);
      var src = wc.getImageData(0, 0, w, h).data;
      var ctx = canvas.getContext('2d'), out = ctx.createImageData(w, h), d = out.data;
      var lit = state.lit || led(), col = color();
      var gray = new Float32Array(w * h);
      for (var i = 0, j = 0; i < gray.length; i++, j += 4) gray[i] = 0.299 * src[j] + 0.587 * src[j + 1] + 0.114 * src[j + 2];
      for (var y = 0; y < h; y++) {
        for (var x = 0; x < w; x++) {
          var k = y * w + x, p = k * 4, r, g, b;
          if (lit) {
            // Backlit: thin (light) areas glow warm, thick (dark) areas stay dark.
            if (col) {
              r = src[p] * 1.05 + 10; g = src[p + 1] * 0.98 + 6; b = src[p + 2] * 0.88;
            } else {
              var v = Math.pow(gray[k] / 255, 1.15) * 255;
              r = v * 1.04 + 8; g = v * 0.93 + 4; b = v * 0.76;
            }
          } else {
            // Unlit: a pale textured tile; the photo only shows as relief, like light catching the surface.
            var a = gray[Math.max(0, y - 1) * w + Math.max(0, x - 1)], c = gray[Math.min(h - 1, y + 1) * w + Math.min(w - 1, x + 1)];
            var relief = 222 + (c - a) * 0.9 - (255 - gray[k]) * 0.05;
            r = relief; g = relief - 3; b = relief - 9;
            if (col) { r += (src[p] - gray[k]) * 0.12; g += (src[p + 1] - gray[k]) * 0.12; b += (src[p + 2] - gray[k]) * 0.12; }
          }
          var line = y % 3 === 0 ? 0.96 : 1; // faint print layers
          d[p] = Math.min(255, r * line);
          d[p + 1] = Math.min(255, g * line);
          d[p + 2] = Math.min(255, b * line);
          d[p + 3] = 255;
        }
      }
      ctx.putImageData(out, 0, 0);
      stage.classList.toggle('is-lit', lit);
      stage.classList.toggle('is-framed', framed());
      stage.classList.toggle('is-led', led());
      stage.classList.toggle('is-landscape', landscape());
      box.querySelectorAll('#lp-light button').forEach(function (b) { b.classList.toggle('is-on', (b.dataset.lit === '1') === lit); });
      $('#lp-light').classList.toggle('is-locked', led());
      $('.lp-caption').textContent = state.style + ' / ' + state.display + ' / ' + (landscape() ? 'Landscape' : 'Portrait') + ' 4 x 6 in';
    }

    function loadFile() {
      err.hidden = true;
      var file = input.files[0];
      state.img = null; state.ox = 0; state.oy = 0; zoom.value = 100;
      if (!file) {
        fileRow.hidden = true; ui.hidden = false; drop.classList.remove('is-filled');
        lp.hidden = true;
        return;
      }
      if (file.size > MAX_BYTES) {
        input.value = '';
        loadFile();
        showError('That photo is over 20 MB. Please choose a smaller version.');
        return;
      }
      fileRow.querySelector('.a3-upload__name').textContent = file.name;
      fileRow.hidden = false; ui.hidden = true; drop.classList.add('is-filled');
      var thumb = fileRow.querySelector('img');
      var url = URL.createObjectURL(file);
      var img = new Image();
      img.onload = function () {
        state.img = img;
        thumb.src = url; thumb.hidden = false;
        // Start in the orientation that fits the photo best.
        orient.value = img.naturalWidth > img.naturalHeight ? 'Landscape (wide)' : 'Portrait (tall)';
        lp.hidden = false;
        render();
      };
      img.onerror = function () {
        // HEIC and other formats can still be ordered; we just cannot draw them in the browser.
        thumb.hidden = true;
        lp.hidden = true;
        showError('We cannot preview this file type, but you can still order with it. For a preview, upload a JPG or PNG.');
      };
      img.src = url;
    }

    function setBusy(on) {
      busy = on;
      if (!addButton) return;
      addButton.classList.toggle('loading', on);
      if (on) { addButton.setAttribute('aria-disabled', 'true'); } else { addButton.removeAttribute('aria-disabled'); }
    }

    // The exact crop the customer framed, full color at 300 pixels per inch, for printing.
    function cropBlob() {
      if (!state.img) return Promise.resolve(null);
      var w = (landscape() ? PANEL_IN[1] : PANEL_IN[0]) * DPI * EXPORT_SCALE;
      var h = (landscape() ? PANEL_IN[0] : PANEL_IN[1]) * DPI * EXPORT_SCALE;
      var c = document.createElement('canvas');
      c.width = w; c.height = h;
      drawCrop(c.getContext('2d'), w, h);
      return new Promise(function (resolve) { c.toBlob(resolve, 'image/jpeg', 0.92); });
    }

    function post(fd) {
      return fetch('/cart/add.js', { method: 'POST', headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json' }, body: fd })
        .then(function (res) { return res.json().then(function (data) { return { ok: res.ok && !data.status, data: data }; }); });
    }

    function addToCart(e) {
      e.preventDefault();
      e.stopImmediatePropagation();
      if (busy) return;
      err.hidden = true;
      if (!input.files.length) {
        showError('Please upload your photo before adding to cart.');
        return;
      }
      setBusy(true);
      cropBlob()
        .then(function (blob) {
          var fd = new FormData(form);
          if (!$('#a3-notes').value.trim()) fd.delete('properties[Notes]');
          if (blob) fd.append('properties[Print crop]', new File([blob], 'lithophane-crop.jpg', { type: 'image/jpeg' }));
          return post(fd);
        })
        .then(function (r) {
          if (!r.ok) {
            setBusy(false);
            showError(r.data.description || 'Something went wrong adding this to your cart. Please try again.');
            return;
          }
          window.location.href = '/cart';
        })
        .catch(function () {
          setBusy(false);
          showError('Your photo could not be uploaded. Check your connection and try again.');
        });
    }

    input.addEventListener('change', loadFile);
    ['dragenter', 'dragover'].forEach(function (t) { drop.addEventListener(t, function () { drop.classList.add('is-over'); }); });
    ['dragleave', 'drop'].forEach(function (t) { drop.addEventListener(t, function () { drop.classList.remove('is-over'); }); });
    $('.a3-upload__clear').addEventListener('click', function () { input.value = ''; loadFile(); input.click(); });
    orient.addEventListener('change', function () { state.ox = 0; state.oy = 0; render(); });
    zoom.addEventListener('input', render);
    $('#lp-light').addEventListener('click', function (e) {
      var b = e.target.closest('button');
      if (!b || led()) return;
      state.lit = b.dataset.lit === '1';
      render();
    });
    document.addEventListener('change', function (e) {
      if (e.target.name === 'Style') { state.style = e.target.value; render(); }
      if (e.target.name === 'Display') { state.display = e.target.value; render(); }
    });

    // Drag the photo to choose the crop.
    var drag = null;
    canvas.addEventListener('pointerdown', function (e) {
      if (!state.img) return;
      drag = { x: e.clientX, y: e.clientY };
      canvas.setPointerCapture(e.pointerId);
      hint.hidden = true;
    });
    canvas.addEventListener('pointermove', function (e) {
      if (!drag) return;
      var r = canvas.getBoundingClientRect();
      state.ox += (e.clientX - drag.x) / r.width;
      state.oy += (e.clientY - drag.y) / r.height;
      drag = { x: e.clientX, y: e.clientY };
      render();
    });
    ['pointerup', 'pointercancel'].forEach(function (t) { canvas.addEventListener(t, function () { drag = null; }); });

    // Capture phase on document runs before the theme's and any app's handlers on the button or form.
    document.addEventListener('click', function (e) {
      if (addButton && e.target.closest && e.target.closest('[type=submit][name=add]') === addButton) addToCart(e);
    }, true);
    document.addEventListener('submit', function (e) {
      if (e.target === form) addToCart(e);
    }, true);

    panel.style.touchAction = 'none';
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
